import React, { useState } from 'react';
import { FiSearch, FiX, FiEye, FiTrash2 } from 'react-icons/fi';
import { FaUser, FaSitemap } from 'react-icons/fa';
import HRMSidebar from '../components/HRMSidebar';
import useLocalState from '../hooks/useLocalState';
import { sortData, getNextStatus } from '../utils/tableUtils';

const initialData = [
  { ref: '20', emp: 'Wan Yee Lui', state: 'Present', date: '05/03/2026', start: '10:00', end: '18:00' },
  { ref: '19', emp: 'Wan Yee Lui', state: 'Present', date: '04/03/2026', start: '09:00', end: '18:00' },
  { ref: '18', emp: 'Wan Yee Lui', state: 'Present', date: '02/03/2026', start: '09:00', end: '18:00' },
  { ref: '17', emp: 'Wan Yee Lui', state: 'Present', date: '27/02/2026', start: '11:00', end: '17:00' },
  { ref: '16', emp: 'Wan Yee Lui', state: 'Present', date: '26/02/2026', start: '10:00', end: '16:00' },
  { ref: '13', emp: 'Wan Yee Lui', state: 'Present', date: '23/02/2026', start: '10:00', end: '18:00' },
  { ref: '12', emp: 'Wan Yee Lui', state: 'Present', date: '16/02/2026', start: '10:00', end: '17:00' },
  { ref: '11', emp: 'Wan Yee Lui', state: 'Present', date: '13/02/2026', start: '11:00', end: '17:00' },
  { ref: '10', emp: 'Wan Yee Lui', state: 'Present', date: '12/02/2026', start: '12:00', end: '18:00' },
  { ref: '9', emp: 'Wan Yee Lui', state: 'Present', date: '10/02/2026', start: '10:00', end: '18:00' },
  { ref: '8', emp: 'Wan Yee Lui', state: 'Present', date: '09/02/2026', start: '10:00', end: '18:00' },
  { ref: '7', emp: 'Wan Yee Lui', state: 'Present', date: '06/02/2026', start: '10:00', end: '13:00' },
];

export default function Presences() {
  const [data, setData] = useLocalState('presences_data_v2', initialData);
  const [sortConfig, setSortConfig] = useState({ key: 'date', direction: 'desc' });

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') direction = 'desc';
    setSortConfig({ key, direction });
  };

  const handleStatusChange = (rowToUpdate) => {
    const nextStatus = getNextStatus(rowToUpdate.state, ['Present', 'Absent', 'Late']);
    setData(data.map(row => row === rowToUpdate ? { ...row, state: nextStatus } : row));
  };

  const sortedData = sortData(data, sortConfig);

  const SortIcon = ({ column }) => {
    if (sortConfig.key !== column) return <span className="text-[10px] text-gray-400 opacity-0 group-hover:opacity-100 ml-1">▲</span>;
    return <span className="text-[10px] text-black ml-1">{sortConfig.direction === 'asc' ? '▲' : '▼'}</span>;
  };

  return (
    <div className="flex h-full font-sans overflow-hidden bg-white">
      <HRMSidebar />
      <div className="flex-1 flex flex-col bg-[#a6e4e7] p-2">
        <div className="flex justify-between items-start mb-2 px-1 text-gray-800">
          <div className="flex items-center space-x-2 pt-2">
            <FaSitemap className="text-xl text-black" />
            <span className="font-medium text-[15px] text-teal-700">List of Presences ({data.length})</span>
          </div>
          <div className="flex flex-col items-end space-y-2">
            <select className="border border-gray-400 bg-white py-1 px-2 text-sm rounded-sm outline-none w-16 shadow-sm">
              <option>20</option>
            </select>
            <button className="bg-[#a9a9a9] text-white px-4 py-1.5 rounded-[3px] text-[11px] font-bold tracking-wide shadow-sm hover:bg-gray-500 transition-colors">
              ATTENDANCE REQUEST
            </button>
          </div>
        </div>

        <div className="flex-1 overflow-x-auto shadow-sm">
          <table className="min-w-full border-collapse text-[13px] text-gray-800 bg-white border border-black">
            <thead>
              <tr className="bg-[#a6e4e7] select-none">
                <th onClick={() => handleSort('ref')} className="font-normal p-2 border border-black text-center text-gray-700 cursor-pointer hover:bg-teal-200 group">Ref. <SortIcon column="ref" /></th>
                <th onClick={() => handleSort('emp')} className="font-normal p-2 border border-black text-center text-gray-700 cursor-pointer hover:bg-teal-200 group">Employe <SortIcon column="emp" /></th>
                <th onClick={() => handleSort('state')} className="font-normal p-2 border border-black text-center text-gray-700 cursor-pointer hover:bg-teal-200 group">Etat <SortIcon column="state" /></th>
                <th onClick={() => handleSort('date')} className="font-normal p-2 border border-black text-center text-gray-700 cursor-pointer hover:bg-teal-200 group">Date <SortIcon column="date" /></th>
                <th onClick={() => handleSort('start')} className="font-normal p-2 border border-black text-center text-gray-700 cursor-pointer hover:bg-teal-200 group">On Time <SortIcon column="start" /></th>
                <th onClick={() => handleSort('end')} className="font-normal p-2 border border-black text-center text-gray-700 cursor-pointer hover:bg-teal-200 group">Until the hour <SortIcon column="end" /></th>
                <th className="font-normal p-2 border border-black text-center text-gray-700">Event</th>
              </tr>
              <tr className="bg-[#a6e4e7]">
                <td className="p-1.5 border border-black"></td>
                <td className="p-1.5 border border-black px-4">
                  <select className="w-full border border-gray-400 p-1 bg-[#a6e4e7] outline-none h-7 shadow-inner"><option></option></select>
                </td>
                <td className="p-1.5 border border-black px-8">
                  <select className="w-full border border-gray-400 p-1 bg-white outline-none h-7 shadow-inner"><option></option></select>
                </td>
                <td className="p-1.5 border border-black px-6">
                  <input type="text" className="w-full border border-gray-400 p-1 bg-white outline-none h-7 shadow-inner" />
                </td>
                <td className="p-1.5 border border-black px-4">
                  <input type="text" placeholder="H:mn" className="w-full border border-gray-400 p-1 bg-white outline-none h-7 text-center text-gray-400 placeholder-gray-300 shadow-inner" />
                </td>
                <td className="p-1.5 border border-black px-4">
                  <input type="text" placeholder="H:mn" className="w-full border border-gray-400 p-1 bg-white outline-none h-7 text-center text-gray-400 placeholder-gray-300 shadow-inner" />
                </td>
                <td className="p-1.5 border border-black text-center">
                  <div className="flex justify-center space-x-3 text-lg font-bold">
                    <FiSearch className="text-black cursor-pointer hover:opacity-70" />
                    <FiX className="text-black cursor-pointer hover:opacity-70" />
                  </div>
                </td>
              </tr>
            </thead>
            <tbody>
              {sortedData.map((row, idx) => (
                <tr key={idx} className="bg-white hover:bg-blue-50 transition-colors">
                  <td className="p-2 border border-black text-center text-gray-800 whitespace-nowrap">
                    <FaUser className="inline mr-2 text-black" /> {row.ref}
                  </td>
                  <td className="p-2 border border-black text-center text-teal-800 whitespace-nowrap">
                    <FaUser className="inline mr-2 text-[#8b4513]" /> {row.emp}
                  </td>
                  <td className="p-2 border border-black text-center">
                    <span onClick={() => handleStatusChange(row)} className={`cursor-pointer px-3 py-0.5 rounded-full text-[12px] font-medium shadow-sm transition-colors ${
                      row.state === 'Present' ? 'bg-[#5cb85c] text-white hover:bg-green-600' : 
                      row.state === 'Absent' ? 'bg-[#d9534f] text-white hover:bg-red-600' : 
                      'bg-[#f0ad4e] text-white hover:bg-yellow-600'
                    }`}>
                      {row.state}
                    </span>
                  </td>
                  <td className="p-2 border border-black text-center text-gray-800">{row.date}</td>
                  <td className="p-2 border border-black text-center text-gray-800">{row.start}</td>
                  <td className="p-2 border border-black text-center text-gray-800">{row.end}</td>
                  <td className="p-2 border border-black text-center">
                    <div className="flex justify-center space-x-3 text-black">
                      <FiEye className="cursor-pointer hover:text-blue-600 text-lg" />
                      <FiTrash2 className="cursor-pointer hover:text-red-600 text-lg" />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}